require('./bootstrap');
import Vue from 'vue';

import { VueMaskDirective } from 'v-mask'

Vue.directive('mask', VueMaskDirective);

import { VueMaskFilter } from 'v-mask'

Vue.filter('VMask', VueMaskFilter)

import search_view from './views/search/search.vue';
window.vue_search = new Vue({
    data:{
    },
    components: {
        'search-view': search_view,
    },
    methods:{
    }
}).$mount('#search-vue');

if($('#search-vue-1').length > 0){
    window.vue_search_1 = new Vue({
        data:{
        },
        components: {
            'search-view': search_view,
        },
        methods:{
        }
    }).$mount('#search-vue-1');
}